export default "<div class=\"row\">\r\n  <div class=\"col-md-12 \">\r\n    <app-category-list></app-category-list>\r\n  </div>\r\n</div>\r\n"